import React from 'react'
import { makeIcon } from './icons'
import { useTranslatedText } from './StaticTextContext'

interface OracleScrollIndicatorProps {
  isVisible: boolean
  onClick: () => void
  className?: string
}

const OracleScrollIndicator: React.FC<OracleScrollIndicatorProps> = ({
  isVisible,
  onClick,
  className = '',
}) => {
  const scrollToBottomLabel = useTranslatedText({ keys: ['accessibility', 'scrollToBottom'] })

  if (!isVisible) {
    return null
  }

  return (
    <button
      className={`oracle-scroll-indicator ${className}`.trim()}
      onClick={onClick}
      type="button"
      aria-label={scrollToBottomLabel}
    >
      {makeIcon('arrow-down', '16px')}
    </button>
  )
}

export { OracleScrollIndicator }
export default OracleScrollIndicator
